{
	"name": "missile",
	"size": [32, 32],
	"kit": "arcade",
	"frames": { "count": 6, "drive": "burn", "curve": "pulse" },
	"parts": [
		{ "shape": "taper", "inset": [12, 2, 12, 22], "role": "accent", "litRole": "accent_lit", "shadeRole": "accent_dark", "narrow": 0.85, "towards": "top" },
		{ "shape": "taper", "inset": [12, 7, 12, 8], "role": "metal", "litRole": "metal_lit", "shadeRole": "metal_dark", "narrow": 0.1, "towards": "top" },
		{ "shape": "panel", "inset": [13, 11, 13, 15], "role": "accent_dark" },
		{ "shape": "taper", "inset": [7, 16, 18, 6], "role": "metal_dark", "narrow": 0.75, "towards": "top" },
		{ "shape": "taper", "inset": [18, 16, 7, 6], "role": "metal_dark", "narrow": 0.75, "towards": "top" },
		{ "shape": "panel", "inset": [13, 22, 13, 8], "role": "metal_dark" },
		{ "shape": "taper", "inset": [12, 24, 12, 2], "role": "hot", "litRole": "hot_lit", "narrow": 0.7, "towards": "bottom" },
		{ "shape": "mover", "from": [15, 27], "to": [15, 30], "value": "burn", "role": "hot_lit", "trailRole": "hot", "size": [2, 1], "count": 2, "offset": 0.5, "wrap": true }
	]
}
